
import React from "react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import OperationalFlow from "@/components/OperationalFlow";
import OperationalExample from "@/components/OperationalExample";
import ContactRepresentative from "@/components/ContactRepresentative";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowDownCircle } from "lucide-react";

const HowWeOperate = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      title: "Comment nous opérons",
      subtitle: "Une infrastructure sécurisée pour traverser le temps",
      description: "Notre approche combine sécurité technologique, conformité légale et gestion financière éthique pour garantir que vos messages et contributions traversent les années en toute sécurité selon les standards européens.",
      buttonText: "Créer votre capsule temporelle",
    },
    en: {
      title: "How We Operate",
      subtitle: "A secure infrastructure to traverse time",
      description: "Our approach combines technological security, legal compliance, and ethical financial management to ensure your messages and contributions safely cross the years under European Union standards.",
      buttonText: "Create Your Time Capsule",
    },
    de: {
      title: "Wie wir arbeiten",
      subtitle: "Eine sichere Infrastruktur, um die Zeit zu durchqueren",
      description: "Unser Ansatz kombiniert technologische Sicherheit, rechtliche Konformität und ethisches Finanzmanagement, um sicherzustellen, dass Ihre Nachrichten und Beiträge die Jahre sicher unter den Standards der Europäischen Union überstehen.",
      buttonText: "Erstellen Sie Ihre Zeitkapsel",
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="how-we-operate" />
      
      <main className="flex-grow">
        {/* Hero Section with enhanced visual appeal */}
        <section className="relative bg-gradient-to-b from-legatia-blue/5 via-white to-transparent pt-32 pb-20 px-4">
          <div className="container mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
                {content[language].title}
              </h1>
              <p className="text-xl md:text-2xl font-medium mb-8 text-gray-700">
                {content[language].subtitle}
              </p>
              <p className="text-lg text-gray-700 mb-10 max-w-2xl mx-auto">
                {content[language].description}
              </p>
              <Button 
                className="btn-primary"
                onClick={() => window.location.href = "https://app.getlegatia.ch/"}
              >
                {content[language].buttonText}
              </Button>
              
              <div className="mt-16 animate-bounce">
                <ArrowDownCircle className="h-10 w-10 text-legatia-orange mx-auto opacity-70" />
              </div>
            </div>
          </div>

          {/* Background illustration */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-6xl -z-10 opacity-5">
            <img 
              src="/assets/operation-diagram.svg" 
              alt="Operation diagram" 
              className="w-full h-full object-contain"
            />
          </div>
        </section>
        
        {/* Process Flow with improved visual styling */}
        <OperationalFlow />
        
        {/* Example Case with improved spacing */}
        <OperationalExample />
        
        {/* Contact Section */}
        <ContactRepresentative />
      </main>
      
      <Footer />
    </div>
  );
};

export default HowWeOperate;
